module.exports = __webpack_public_path__ + "static/media/children.5dae741a.jpg";